import { CardWrapper } from './card.styles';
import type { CardProps } from './card.types';

function Card({
  children,
  ...props
}: CardProps & { children: React.ReactNode }): JSX.Element {
  return <CardWrapper {...props}>{children}</CardWrapper>;
}

export { Card };
